
import './BannerUploader.css';
import { ImProfile } from 'react-icons/im';
import { useAtom } from 'jotai';
import { useLoggedUser, useShowPopUpModal, useModalInfo, useModalVersion } from '../../../data/GlobalStates';

const BannerUploader = () => {

      const [ ShowPopUpModal, setShowPopUpModal] = useAtom(useShowPopUpModal);
      const [ ModalVersion, setModalVersion] = useAtom(useModalVersion);
      const [ LoggedUser, setLoggedUser ] = useAtom(useLoggedUser);
      const [ ModalInfo, setModalInfo] = useAtom(useModalInfo);
  
      const removeBaner = () => {
         setShowPopUpModal(true)
         setModalInfo({title: 'Usunąć Baner ?'})
         setModalVersion(41)
      };

      const addBaner = () => {
        setShowPopUpModal(true)
        setModalInfo({title: 'Dodaj Baner'})
        setModalVersion(39)
      };

  return (
    <div>
        <div>
               { LoggedUser.BannerUrl ?
               <div className='EditBtns' onClick={removeBaner}>
                <p>Usuń baner</p>
                <ImProfile />
               </div>
               :
               <div className='EditBtns' onClick={addBaner}>
                 <p>Dodaj baner</p>
                 <ImProfile />
               </div>
               }
           </div>
    </div>
  )
}

export default BannerUploader;
